// Hook into Turbo's existing ActionCable system for custom message handling
document.addEventListener('turbo:load', function () {
  const streamElements = document.querySelectorAll('turbo-cable-stream-source');

  streamElements.forEach((element) => {
    element.addEventListener('message', function (event) {
      const data = event.data;

      if (data && data.action === 'chrome_data_ready') {
        handleChromeDataReady(data);
      } else if (data && data.action === 'chrome_data_error') {
        handleChromeDataError(data);
      } else if (data && data.action === 'reprocess_complete') {
        handleReprocessComplete(data);
      } else if (data && data.action === 'reprocess_error') {
        handleReprocessError(data);
      }
    });
  });
});

function handleChromeDataReady(data) {
  const currentPath = window.location.pathname;
  const isSearchPage = currentPath.includes('/decode') || currentPath.includes('/vin_compare') || currentPath.includes('/vin_decode');

  if (isSearchPage) {
    console.log(`Chrome data ready for search ${data.search_id}, reloading...`);
    const loadingCard = document.getElementById('loading-gif');
    if (loadingCard) {
      window.location.reload();
    } else {
      const searchContainer = document.querySelector(`#${data.search_type}-vin-search-${data.search_id}`);
      if (searchContainer) {
        window.location.reload();
      }
    }
  }
}

function handleChromeDataError(data) {
  console.error(`Chrome data error for search ${data.search_id}`);
  const currentPath = window.location.pathname;
  const isSearchPage = currentPath.includes('/decode') || currentPath.includes('/vin_compare') || currentPath.includes('/vin_decode');

  if (isSearchPage) {
    // Reload to show error state
    window.location.reload();
  }
}

function handleReprocessComplete(data) {
  if (window.location.pathname.includes(data.vin_number.toLowerCase())) {
    window.location.reload();
  }
}

function handleReprocessError(data) {
  if (window.location.pathname.includes(data.vin_number.toLowerCase())) {
    alert('Unable to load detailed VIN information. Please try refreshing the page.');
  }
}